var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plist-filter"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"filter-category"},[_vm._t("category")],2),_c('div',{staticClass:"filter-brand"},[_vm._t("brand")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }